import React, { useEffect, useState, useMemo, useRef } from "react"
import { Card, Form, Nav, Tab, Button, Dropdown, CloseButton } from "react-bootstrap"
import api from "../../../../services/api"
import Cookies from 'js-cookie'
import { Link, useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import EmojiPicker from 'emoji-picker-react';
import { FaArrowDown } from "react-icons/fa";
import { io } from 'socket.io-client'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { set_selected_friend } from "../../../../store/setting/actions"
import { set_selected_group } from "../../../../store/setting/actions"
import { set_friend_messages, set_new_friend_messages } from "../../../../store/setting/actions"
import { set_group_messages, set_new_group_messages } from "../../../../store/setting/actions"
import { set_active_users } from "../../../../store/setting/actions"
import { set_receive_new_messages } from "../../../../store/setting/actions"
import { IoCheckmarkDoneSharp } from "react-icons/io5"
import { IoMdClose } from "react-icons/io";
import { MdAssistant } from "react-icons/md";
import TextMessageComponent from "../../../TextMessageComponent";
import ImageMessageComponent from "../../../ImageMessageComponent";
import './styles.css'
import 'react-photo-view/dist/react-photo-view.css';
import { saveAs } from 'file-saver';

//image
import userGenericImage from '../../../../assets/images/generic_user.png'
import logoAtmoAi from '../../../../assets/images/ATMO_AI.png'

const RightSidebar = () => {
  const messageRefs = useRef({});
  const dispatch = useDispatch();
  const history = useNavigate()
  const customId = 'success-toast-id'
  const token = Cookies.get('token')
  const loged_user = Cookies.get('userId')
  const userStatus = Cookies.get('userStatus')
  const chatBodyRef = useRef(null)
  const groupChatBodyRef = useRef(null)
  const socket = useRef(null)
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [showGroupScrollButton, setShowGroupScrollButton] = useState(false);
  const [friends, setFriends] = useState([])
  const [newFiends, setNewFriends] = useState([])
  const [groups, setGroups] = useState([])
  const [textMessage, setTextMessage] = useState('')
  const [groupTextMessage, setGroupTextMessage] = useState('')
  const [search, setSearch] = useState('')
  const [showPicker, setShowPicker] = useState(false)
  const [showGroupPicker, setShowGroupPicker] = useState(false)
  const [deletedMessage, setDeletedMessage] = useState([])
  const [editedMessages, setEditedMessages] = useState([])
  const selectedFriend = useSelector((state) => state.setting.setting.selected_friend);
  const selectedGroup = useSelector((state) => state.setting.setting.selected_group);
  const messages = useSelector((state) => state.setting.setting.friend_messages);
  const groupMessages = useSelector((state) => state.setting.setting.group_messages);
  const [isLoading, setIsLoading] = useState(false);
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [selectedMode, setSelectedMode] = useState('text');
  const [wasBlocked, setwasBlocked] = useState(selectedFriend?.someone_blocked)
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  const [messageToReply, setMessageToReply] = useState('')
  const [messageToReplyId, setMessageToReplyId] = useState(null)
  const [messageAuthor, setMessageToReplyAuthor] = useState('')
  const [showEdit, setShowEdit] = useState(false)
  const [editedChatId, setEditedChatId] = useState('')
  const [newText, setNewText] = useState('')
  const [file, setFile] = useState(null);
  const [blocked, setBlocked] = useState(false)
  
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    scrollToBottom()
  };

  const removeImage = () => {
    setFile(null)
  }

  const handleSelect = (mode) => {
    setSelectedMode(mode);
  };

  const blockContact = async (contactId) => {
    try {
      await api.put(`/api/chat/block/${contactId}`);

      if (blocked) {
        setwasBlocked(false)
      }

      setBlocked(!blocked)
    } catch (error) {
      console.error('Failed to block contact:', error);

      toast.error('Erro ao bloquear/desbloquear contato', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const setReplyMessage = (message, messageId, author = '') => {
    setMessageToReply(message)
    setMessageToReplyId(messageId)
    setMessageToReplyAuthor(author)
  }

  const checkIfUserWasBlocked = async (userId) => {
    try {
      const response = await api.get(`/api/chat/checkIfUserWasBlocked/${userId}`)

      setwasBlocked(response.data.someone_blocked)
    } catch (error) {
      toast.error('Erro ao checar se usuário foi bloqueado', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const marcarComoLidas = (currentMessages) => {
    if (Array.isArray(currentMessages)) {
      const mensagensAtualizadas = currentMessages.map(message => {
        if (!message.readed) {
          return { ...message, readed: true };
        }
        return message;
      });

      dispatch(set_friend_messages(mensagensAtualizadas))
    }
  };

  const readFriendMessages = (friendId, friends) => {
    if (Array.isArray(friends)) {
      const updatedFriends = friends.map(friend => {
        if (friend.id == friendId) {
          return { ...friend, unread_messages: 0 };
        }
        return friend;
      });

      setFriends(updatedFriends)
    }
  }

  const readGroupMessages = (groupId, groups) => {
    if (Array.isArray(groups)) {
      const updatedGroups = groups.map(group => {
        if (group.id == groupId) {
          return { ...group, unread_messages: 0 };
        }
        return group;
      });

      setGroups(updatedGroups)
    }
  }

  const changeStatus = (friendId, friends, status) => {
    if (Array.isArray(friends)) {
      const updatedFriends = friends.map(friend => {
        if (friend.id == friendId) {
          let newFriend = { ...friend, chat_status: status };

          if (selectedFriend && selectedFriend.id == friendId) {
            dispatch(set_selected_friend(newFriend))
          }

          return newFriend;
        }
        return friend;
      });

      setFriends(updatedFriends)
    }
  }

  const setLastMessage = (message, chats, isFirstMessage = false, sending = false) => {
    if (Array.isArray(chats)) {
      const moveToTop = (updatedChats, index) => {
        const chatToMove = updatedChats.splice(index, 1)[0];
        return [chatToMove, ...updatedChats];
      };

      if (message.group_id) {
        if (sending) {
          const updatedChats = chats.map(chat => {
            if (chat.id == message.group_id) {
              return { ...chat, latest_message: message.message, latest_message_time: 'Agora' };
            }
            return chat;
          });

          const chatIndex = updatedChats.findIndex(chat => chat.id == message.group_id);
          const reorderedChats = moveToTop(updatedChats, chatIndex);

          setGroups(reorderedChats);
        } else {
          const updatedChats = chats.map(chat => {
            if (chat.id == message.group_id) {
              return { ...chat, latest_message: message.message, latest_message_time: 'Agora', unread_messages: chat.unread_messages + 1 };
            }
            return chat;
          });

          const chatIndex = updatedChats.findIndex(chat => chat.id == message.group_id);
          const reorderedChats = moveToTop(updatedChats, chatIndex);

          setGroups(reorderedChats);
        }

      } else if (!isFirstMessage) {
        if (sending) {
          const updatedChats = chats.map(chat => {
            if (chat.id == message.sender_id || chat.id == message.receiver_id) {
              return { ...chat, latest_message: message.message, latest_message_time: 'Agora' };
            }
            return chat;
          });

          const chatIndex = updatedChats.findIndex(chat =>
            chat.id == message.sender_id || chat.id == message.receiver_id
          );
          const reorderedChats = moveToTop(updatedChats, chatIndex);

          setFriends(reorderedChats);
        } else {
          const updatedChats = chats.map(chat => {
            if (chat.id == message.sender_id || chat.id == message.receiver_id) {
              return { ...chat, latest_message: message.message, latest_message_time: 'Agora', unread_messages: chat.unread_messages + 1 };
            }
            return chat;
          });

          const chatIndex = updatedChats.findIndex(chat =>
            chat.id == message.sender_id || chat.id == message.receiver_id
          );
          const reorderedChats = moveToTop(updatedChats, chatIndex);

          setFriends(reorderedChats);
        }
      }
    }
  }

  const minirightsidebar = () => {
    getFriends()
    getGroups()
    getNewFriends()
    document.getElementById("rightSidebar").classList.toggle("right-sidebar")
    document.body.classList.toggle("right-sidebar-close")
  }

  const handleScroll = () => {
    const chatBody = chatBodyRef.current;
    if (chatBody.scrollTop < chatBody.scrollHeight - chatBody.clientHeight - 100) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  const handleScrollGroup = () => {
    const groupChatBody = groupChatBodyRef.current;
    if (groupChatBody.scrollTop < groupChatBody.scrollHeight - groupChatBody.clientHeight) {
      setShowGroupScrollButton(true);
    } else {
      setShowGroupScrollButton(false);
    }
  };

  const getFriends = async () => {
    try {
      const response = await api.post(`/api/friends/show`, {
        loged_user,
        token,
      });

      const data = response.data;
      setFriends(data)
    } catch (error) {
      console.error('Failed to fetch user data:', error);

      toast.error('Erro ao listar amigos', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const getNewFriends = async () => {
    try {
      const response = await api.post(`/api/newFriends/show`, {
        loged_user,
        token,
      });

      const data = response.data;
      setNewFriends(data)
    } catch (error) {
      console.error('Failed to fetch user data:', error);

      toast.error('Erro ao listar novos contatos', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const getGroups = async () => {
    try {
      const response = await api.get(`/api/user/groups/${loged_user}`);

      const data = response.data;
      setGroups(data.groups)
    } catch (error) {
      console.error('Failed to fetch groups data:', error);

      toast.error('Erro ao listar grupos', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const readMessages = async (friend) => {
    try {
      await api.post(`/api/chat/readMessages`, {
        logged_user: loged_user,
        friend: friend,
      });
    } catch (error) {
      console.error('Failed to read friend messages:', error);

      toast.error('Erro ao ler mensagens', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const getActiveUsers = async () => {
    try {
      const response = await api.post(`/api/chat/getActiveFriends`);

      const data = response.data;
      dispatch(set_active_users(data))
    } catch (error) {
      console.error('Failed to fetch active users data:', error);

      toast.error('Erro ao listar amigos ativos', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const sendMessage = async (e, groupId = null) => {
    e.preventDefault()

    if (selectedFriend?.id === '0') {
      try {
        const messageToSend = textMessage; // Captura a mensagem do state
        sendMessageToChatGpt(messageToSend); // Envia a mensagem para a rota da API
        setTextMessage(''); // Limpa o campo de texto após o envio
      } catch (error) {
        console.error('Failed to send message:', error);
  
        toast.error('Erro ao enviar mensagem', {
          toastId: customId,
          autoClose: 3000,
        })
      }
    } else {
      setIsSendingMessage(true)

      try {
        if (file) {
          const formData = new FormData()
          formData.append('message', file)
          formData.append('file', file)
          formData.append('type', 'image')
          formData.append('sender_id', loged_user)
          formData.append('receiver_id', groupId ? '' : selectedFriend?.id)
          formData.append('reply_id', messageToReplyId ? messageToReplyId : '')
          formData.append('group_id', '')
          formData.append('is_first_message', messages.length === 0 ? true : false)
          
          const response = await api.post(`/api/chat/store`, formData)
            
          if (groupId) {
            setTextMessage('')

            dispatch(set_new_group_messages((prevMessages) => [...prevMessages, response.data.message]))

            setLastMessage(response.data.message, groups, false, true)
          } else {
            if (messages.length === 0) {
              getFriends()
            }

            setTextMessage('')
            setFile('')

            dispatch(set_new_friend_messages((prevMessages) => [...prevMessages, response.data.message]))

            setLastMessage(response.data.message, friends, messages.length === 0, true)
            getMessages(groupId ? null : selectedFriend?.id)

          }
        }

        if (textMessage !== '' || groupTextMessage !== '') {
          const response = await api.post(`/api/chat/store`, {
            message: groupId ? groupTextMessage : textMessage,
            type: 'text',
            sender_id: loged_user,
            receiver_id: groupId ? null : selectedFriend?.id,
            reply_id: messageToReplyId ? messageToReplyId : null,
            group_id: groupId,
            is_first_message: messages.length === 0 ? true : false,
          });
  
          if (groupId) {
            setGroupTextMessage('')
            dispatch(set_new_group_messages(response.data.message))
  
            setLastMessage(response.data.message, groups, false, true)
          } else {
            if (messages.length === 0) {
              getFriends()
            }
  
            setTextMessage('')
            dispatch(set_new_friend_messages(response.data.message))
  
            setLastMessage(response.data.message, friends, messages.length === 0, true)
          }
        }
  
      } catch (error) {
        setTextMessage('')
        
        if (error.response.data.error === 'Você bloqueou este usuário' || error.response.data.error === 'Você foi bloqueado por este usuário') {
          setwasBlocked(true)
        }

        console.error('Failed to send message:', error);

        toast.error(error.response.data.error, {
          toastId: customId,
          autoClose: 3000,
        })
      }

      setIsSendingMessage(false)
    }

    setMessageToReply('')
    setMessageToReplyAuthor('')
    setMessageToReplyId(null)
  }

  const getMessages = async (friendId) => {
    try {
      const response = await api.get(`/api/chat/listMessagesByFriend/${loged_user}/${friendId}`);

      dispatch(set_friend_messages(response.data.messages))

    } catch (error) {
      console.error('Failed to get messages:', error);

      toast.error('Erro ao listar mensagens', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const getGroupMessages = async (groupId) => {
    try {
      const response = await api.get(`/api/chat/listMessagesByGroup/${groupId}`);

      dispatch(set_group_messages(response.data.messages))

    } catch (error) {
      console.error('Failed to get group messages:', error);

      toast.error('Erro ao listar mensagens de grupo', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const onEmojiClick = (emojiObject, event) => {
    setTextMessage((prevInput) => prevInput + emojiObject.emoji);
    setShowPicker(false);
  }

  async function copyMessage(texto) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(texto).then(() => {
        console.log("Texto copiado com sucesso!");
      }).catch(err => {
        console.error("Erro ao copiar o texto: ", err);
      });
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = texto;

      textArea.style.position = "fixed";
      textArea.style.left = "-9999px";

      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        console.log("Texto copiado com sucesso!");
      } catch (err) {
        console.error("Erro ao copiar o texto: ", err);
      }

      document.body.removeChild(textArea);
    }
  }

  function isImageLink(url) {
    if (typeof url !== 'string') return false;

    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.tiff', '.ico'];
    
    try {
      const parsedUrl = new URL(url);
      return imageExtensions.some(ext => parsedUrl.pathname.toLowerCase().endsWith(ext));
    } catch (e) {
      return false;
    }
  }  

  const onGroupEmojiClick = (emojiObject, event) => {
    setGroupTextMessage((prevInput) => prevInput + emojiObject.emoji);
    setShowGroupPicker(false);
  }

  const scrollToBottom = () => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }

  const scrollToBottomGroup = () => {
    if (groupChatBodyRef.current) {
      groupChatBodyRef.current.scrollTop = groupChatBodyRef.current.scrollHeight;
    }
  }

  function updateEditedMessages(newItem) {
    setEditedMessages((prevItems) => {
      const existingItemIndex = prevItems.findIndex((item) => item.id === newItem.id);

      if (existingItemIndex !== -1) {
        return prevItems.map((item, index) =>
          index === existingItemIndex ? { ...item, text: newItem.text } : item
        );
      } else {
        return [...prevItems, newItem];
      }
    });
  }

  useEffect(() => {
    let clickableElements = document.querySelectorAll(
      '[data-target="chat-popup-modal"]'
    )

    clickableElements.forEach(function (clickableElement) {
      clickableElement.addEventListener("click", function () {
        let targetId = clickableElement.getAttribute("data-target")
        let targetElement = document.getElementById(targetId)
        if (targetElement) {
          targetElement.classList.add("show")
        }
      })
    })

    let closeBtn = document.querySelector(".chat-popup-modal-close")

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        let chatModal = document.getElementById("chat-popup-modal")
        if (chatModal.classList.contains("show")) {
          chatModal.classList.remove("show")
        }
      })
    }
  })

  useEffect(() => {
    let clickableElements = document.querySelectorAll(
      '[data-target="group-chat-popup-modal"]'
    )

    clickableElements.forEach(function (clickableElement) {
      clickableElement.addEventListener("click", function () {
        let targetId = clickableElement.getAttribute("data-target")
        let targetElement = document.getElementById(targetId)
        if (targetElement) {
          targetElement.classList.add("show")
        }
      })
    })

    let closeBtn = document.querySelector(".group-chat-popup-modal-close")

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        let chatModal = document.getElementById("group-chat-popup-modal")
        if (chatModal.classList.contains("show")) {
          chatModal.classList.remove("show")
        }
      })
    }
  })

  useEffect(() => {
    scrollToBottom()
  }, [messages])

  useEffect(() => {
    scrollToBottomGroup()
  }, [groupMessages])

  useEffect(() => {
    getFriends()
    getGroups()
    getNewFriends()
  }, [])

  useEffect(() => {
    socket.current = io(process.env.REACT_APP_CHAT_SOCKET_URL, {
      transports: ['polling', 'websocket'],
      withCredentials: true,
      query: {
        token: token,
        loged_user: loged_user,
        userStatus: userStatus
      },
    });

    socket.current.on('connect', () => {
      console.log('Connected to WebSocket');
      socket.current.emit('subscribe', `chat_workplace_user_${loged_user}`);
    });

    socket.current.on('disconnect', () => {
      console.log('Disconnected from WebSocket');
    });

    return () => {
      if (socket.current) {
        socket.current.disconnect();
      }
    };
  }, [socket, loged_user]);

  const sendMessageToChatGpt = async (message) => {
    setIsLoading(true);
    try {
      if (selectedMode === 'text') {

        const response = await api.post('/api/chatgpt', { message });

        const newMessage = await api.post(`/api/chat/store`, {
          message: textMessage,
          type: 'text',
          sender_id: loged_user,
          receiver_id: 0,
          is_first_message: messages.length === 0 ? true : false,
          readed: true, // Simulando que foi lida
        });

        const chatStore = await api.post(`/api/chat/store`, {
          message: response.data.message,
          type: 'text',
          sender_id: 0,
          receiver_id: loged_user,
          is_first_message: messages.length === 0 ? true : false,
          readed: true, // Simulando que foi lida
        });
        getMessages(0)

      } else if (selectedMode === 'image') {

        const response = await api.post('/api/chatgpt/generateImage', { prompt: message });

        const newMessage = await api.post(`/api/chat/store`, {
          message: textMessage,
          type: 'text',
          sender_id: loged_user,
          receiver_id: 0,
          is_first_message: messages.length === 0 ? true : false,
          readed: true, // Simulando que foi lida
        });

        await api.post('/api/chat/store', {
          message: response.data.image_url,
          type: 'image', // Define como imagem
          sender_id: 0,
          receiver_id: loged_user,
          is_first_message: false,
          readed: true,
        });
        getMessages(0)

      }
    } catch (error) {
      console.error('Failed to send message:', error);
    }
    setIsLoading(false);
  }

  const handleDownload = (src) => {
    saveAs(src, 'image.png');
  };

  const handleChatSelection = (friend) => {
    if (friend.name === "Chat GPT") {
      // Defina a lógica para o chat com a IA
      dispatch(set_selected_friend({ id: '0', name: 'Atmo AI' }));
      dispatch(set_friend_messages([])); // Limpa as mensagens anteriores ou pode carregar um histórico se necessário
    }
    setIsLoading(false)
  }

  const deleteMessage = async (messageId, isGroup = false, chatId) => {
    try {
      await api.delete(`/api/chat/delete/${messageId}`);

      setDeletedMessage([...deletedMessage, messageId])
      
      if (isGroup) {
        const updatedChats = groups.map(chat => {
          if (chat.id == chatId) {
            return { ...chat, latest_message: 'Mensagem apagada' };
          }
          return chat;
        });

        setGroups(updatedChats)
      } else {
        const updatedChats = friends.map(chat => {
          if (chat.id == chatId) {
            return { ...chat, latest_message: 'Mensagem apagada' };
          }
          return chat;
        });

        setFriends(updatedChats)
      }
    } catch (error) {
      console.error('Failed to delete message:', error);

      toast.error('Erro ao remover mensagem', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  const editMessage = async (messageId , isGroup = false, chatId) => {
    try {
      if (newText === '') {
        toast.error('Por favor escreva a nova mensagem.', { autoClose: 3000 })
      } else {
        await api.put(`/api/chat/edit/${messageId}`, {
          newMessage: newText
        });

        updateEditedMessages({
          id: messageId,
          text: newText
        })

        setNewText('')
        setEditedChatId('')
        setShowEdit(false)

        if (isGroup) {
          const updatedChats = groups.map(chat => {
            if (chat.id == chatId) {
              return { ...chat, latest_message: newText };
            }
            return chat;
          });
  
          setGroups(updatedChats)
        } else {
          const updatedChats = friends.map(chat => {
            if (chat.id == chatId) {
              return { ...chat, latest_message: newText };
            }
            return chat;
          });
  
          setFriends(updatedChats)
        }
      }
    } catch (error) {
      console.error('Failed to edit message:', error);

      toast.error('Erro ao editar mensagem', {
        toastId: customId,
        autoClose: 3000,
      })
    }
  }

  useEffect(() => {
    const handleMessage = ({ friend_id, message, groupId, isFirstMessage }) => {
      console.log('mensagem recebida')
      dispatch(set_receive_new_messages(true))

      const selectedFriendId = selectedFriend ? String(selectedFriend.id) : null;
      const selectedGroupId = selectedGroup ? String(selectedGroup.id) : null;
      const messageFriendId = String(friend_id);
      const messageGroupId = String(groupId);

      if (groupId) {
        if (selectedGroupId === messageGroupId) {
          dispatch(set_new_group_messages(message))
        }

        setLastMessage(message, groups)
      } else if (!isFirstMessage) {
        if (selectedFriendId === messageFriendId) {
          readMessages(messageFriendId)
          dispatch(set_new_friend_messages(message))
        }

        setLastMessage(message, friends)
      } else if (isFirstMessage) {
        dispatch(set_new_friend_messages(message))
        getFriends()
      }
    }

    if (socket.current) {
      socket.current.on('newMessage', handleMessage);
    }

    return () => {
      if (socket.current) {
        socket.current.off('newMessage', handleMessage);
      }
    };
  }, [selectedFriend, messages, selectedGroup, groupMessages, friends, groups])

  useEffect(() => {
    const handleReadMessage = () => {
      marcarComoLidas(messages)
      console.log('mensagens lidas')
    }

    if (socket.current) {
      socket.current.on('readedMessage', handleReadMessage);
    }

    return () => {
      if (socket.current) {
        socket.current.off('readedMessage', handleReadMessage);
      }
    };
  }, [messages])

  useEffect(() => {
    const handleNewStatus = ({ friend_id, status }) => {

      changeStatus(friend_id, friends, status)

      getActiveUsers()
    }

    if (socket.current) {
      socket.current.on('newStatus', handleNewStatus);
    }

    return () => {
      if (socket.current) {
        socket.current.off('newStatus', handleNewStatus);
      }
    };
  }, [friends])

  useEffect(() => {
    const handleRemoveMessage = ({ message_id, is_group, chat_id }) => {
      setDeletedMessage([...deletedMessage, message_id])

      if (is_group) {
        const updatedChats = groups.map(chat => {
          if (chat.id == chat_id) {
            return { ...chat, latest_message: 'Mensagem apagada' };
          }
          return chat;
        });

        setGroups(updatedChats)
      } else {
        const updatedChats = friends.map(chat => {
          if (chat.id == chat_id) {
            return { ...chat, latest_message: 'Mensagem apagada' };
          }
          return chat;
        });

        setFriends(updatedChats)
      }
    }

    if (socket.current) {
      socket.current.on('removedMessage', handleRemoveMessage);
    }

    return () => {
      if (socket.current) {
        socket.current.off('removedMessage', handleRemoveMessage);
      }
    };
  }, [deletedMessage, friends, groups])

  useEffect(() => {
    const handleEditMessage = ({ message_id, new_message, is_group, chat_id }) => {
      updateEditedMessages({
        id: message_id,
        text: new_message
      })

      if (is_group) {
        const updatedChats = groups.map(chat => {
          if (chat.id == chat_id) {
            return { ...chat, latest_message: new_message };
          }
          return chat;
        });

        setGroups(updatedChats)
      } else {
        const updatedChats = friends.map(chat => {
          if (chat.id == chat_id) {
            return { ...chat, latest_message: new_message };
          }
          return chat;
        });

        setFriends(updatedChats)
      }
    }

    if (socket.current) {
      socket.current.on('editedMessage', handleEditMessage);
    }

    return () => {
      if (socket.current) {
        socket.current.off('editedMessage', handleEditMessage);
      }
    };
  }, [editedMessages, friends, groups])

  useEffect(() => {
    const handleUserWasBlocked = ({ blocker_id }) => {
      if (selectedFriend?.id === blocker_id) {
        checkIfUserWasBlocked(blocker_id)
      }
    }

    if (socket.current) {
      socket.current.on('wasBlocked', handleUserWasBlocked);
    }

    return () => {
      if (socket.current) {
        socket.current.off('wasBlocked', handleUserWasBlocked);
      }
    };
  }, [wasBlocked, selectedFriend])

  useEffect(() => {
    const chatBody = chatBodyRef.current;
    chatBody.addEventListener("scroll", handleScroll);

    const groupChatBody = groupChatBodyRef.current;
    groupChatBody.addEventListener("scroll", handleScrollGroup);
    return () => {
      chatBody.removeEventListener("scroll", handleScroll);
      groupChatBody.removeEventListener("scroll", handleScrollGroup);
    };
  }, []);

  const filteredFriends = useMemo(() => {
    const lowerSearch = search.toLowerCase()

    if (search === '') {
      return friends
    } else {
      return friends.filter((friend) => friend.name.toLowerCase().includes(lowerSearch) || friend.email.toLowerCase().includes(lowerSearch) || friend.id.toString().toLowerCase().includes(lowerSearch))
    }
  }, [search, friends])

  const filteredNewFriends = useMemo(() => {
    const lowerSearch = search.toLowerCase()

    if (search === '') {
      return newFiends
    } else {
      return newFiends.filter((newFriend) => newFriend.name.toLowerCase().includes(lowerSearch) || newFriend.email.toLowerCase().includes(lowerSearch) || newFriend.id.toString().toLowerCase().includes(lowerSearch))
    }
  }, [search, newFiends])

  const filteredGroups = useMemo(() => {
    const lowerSearch = search.toLowerCase()

    if (search === '') {
      return groups
    } else {
      return groups.filter((group) => group.name.toLowerCase().includes(lowerSearch))
    }
  }, [search, groups])



  const handleFocus = () => {
    setIsKeyboardOpen(true);
  };

  const handleBlur = () => {
    setIsKeyboardOpen(false);
  };

  const scrollToMessage = (id) => {
    const element = messageRefs.current[id];
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 575);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className="right-sidebar-mini" id="rightSidebar">
        <div className="right-sidebar-panel p-0">
          <Card className="shadow-none m-0 h-100">
            <Card.Body className="px-0 pt-0">
              <div className="p-4">
                <div className="mt-4 iq-search-bar device-search div-btn-and-search">
                  <Button className="hide-btn-desk" onClick={minirightsidebar}>
                    <IoMdClose className="fs-3" />
                  </Button>
                  <Form action="#" className="searchbox position-relative">
                    <Link className="search-link" to="#">
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="7.82491"
                          cy="7.82495"
                          r="6.74142"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.5137 12.8638L15.1567 15.5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                    <Form.Control
                      type="text"
                      className="text search-input  bg-light-subtle"
                      placeholder="Procure pessoas ou grupos..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Form>
                </div>
              </div>
              <Tab.Container defaultActiveKey="first">
                {/* <div className='tabs'> */}
                <Nav
                  className="nav-tabs right-sidebar-tabs"
                  id="right-sidebar-tabs"
                  role="tablist"
                >
                  <Nav.Link
                    eventKey={"first"}
                    className="text-center"
                    id="nav-friends-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-friends"
                    type="button"
                    role="tab"
                    aria-controls="nav-friends"
                    aria-selected="true"
                    style={{ 'display': 'flex', 'flexDirection': 'column' }}
                  >
                    <span className="material-symbols-outlined" style={{ color: "var(--bs-body-color)" }}>
                      sms
                    </span>{" "}
                    <span className="h6 font-size-14">Conversas</span>
                  </Nav.Link>

                  <Nav.Link
                    eventKey={"second"}
                    className="text-center"
                    id="nav-groups-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-groups"
                    type="button"
                    role="tab"
                    aria-controls="nav-groups"
                    aria-selected="false"
                    style={{ 'display': 'flex', 'flexDirection': 'column' }}
                  >
                    <span className="material-symbols-outlined" style={{ color: "var(--bs-body-color)" }}>
                      forum
                    </span>{" "}
                    <span className="h6 font-size-14">Grupos</span>
                  </Nav.Link>

                  <Nav.Link
                    eventKey={"third"}
                    className="text-center"
                    id="nav-groups-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-groups"
                    type="button"
                    role="tab"
                    aria-controls="nav-groups"
                    aria-selected="false"
                    style={{ 'display': 'flex', 'flexDirection': 'column' }}
                  >
                    <span className="material-symbols-outlined" style={{ color: "var(--bs-body-color)" }}>
                      chat_add_on
                    </span>{" "}
                    <span className="h6 font-size-14">Novos</span>
                  </Nav.Link>
                </Nav>
                {/* </div> */}
                <div className="media-height" data-scrollbar="init">
                  <Tab.Content className="right-sidebar-tabs-content">
                    <Tab.Pane eventKey="first">
                      <div
                        key={'chat_gpt-0'}
                        onClick={() => {
                          handleChatSelection({ id: '0', name: 'Chat GPT' })
                          setTextMessage('')
                          getMessages(0)
                          setwasBlocked(false)
                        }}
                        className="d-flex align-items-center justify-content-between chat-tabs-content border-bottom contact"
                        data-target="chat-popup-modal"
                      >
                        <div className="d-flex align-items-center gap-3">
                          <div className={`iq-profile-avatar status-online`}>
                            <img
                              className="rounded-circle avatar-50"
                              src={logoAtmoAi}
                              alt="user-img"
                              loading="lazy"
                            />
                          </div>
                          <div>
                            <h6 className="font-size-14 mb-0 fw-semibold">
                              Atmo AI   <MdAssistant style={{ fontSize: "20px", color: " RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1))" }} />
                            </h6>
                          </div>
                        </div>
                      </div>
                      {
                        filteredFriends.map(friend => {
                          let currentUserStatus = friend.chat_status

                          return (
                            <div
                              key={friend.id}
                              className="d-flex align-items-center justify-content-between chat-tabs-content border-bottom contact"
                              data-target="chat-popup-modal"
                              onClick={() => {
                                dispatch(set_selected_friend(friend))
                                checkIfUserWasBlocked(friend.id)
                                setTextMessage('')
                                getMessages(friend.id)
                                readMessages(friend.id)
                                readFriendMessages(friend.id, friends)
                              }}
                            >
                              <div className="d-flex align-items-center gap-3">
                                <div className={`iq-profile-avatar ${currentUserStatus === 'online' ? 'status-online' : currentUserStatus === 'away' ? 'status-away' : 'status-offline'}`}>
                                  <img
                                    className="rounded-circle avatar-50"
                                    src={friend.user_about.image_profile ?? userGenericImage}
                                    alt="user-img"
                                    loading="lazy"
                                  />
                                </div>
                                <div>
                                  <h6 className="font-size-14 mb-0 fw-semibold text-nowrap overflow-hidden" style={{ maxWidth: '7rem' }}>
                                    {friend.name}
                                  </h6>
                                  <p className="mb-0 font-size-12 fw-medium text-nowrap overflow-hidden" style={{ maxWidth: '7rem'}}>
                                    {friend.latest_message && /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(friend.latest_message) ? (
                                      <span className="image-text fst-italic d-flex align-items-center">
                                        <span className="material-symbols-outlined fs-6 me-1">
                                          image
                                        </span> Imagem
                                      </span>
                                    ) : (
                                      friend.latest_message ?? "Nova conversa..."
                                    )}
                                  </p>
                                </div>
                              </div>
                              <span className="font-size-12 fw-medium messages-counter-span">
                                {friend.latest_message_time ?? ''}
                                {
                                  friend.unread_messages > 0 ? (
                                    <div className="counter-container bg-primary">
                                      <span className="counter-number">{friend.unread_messages}</span>
                                    </div>
                                  ) : ''
                                }
                              </span>
                            </div>
                          )
                        })
                      }
                    </Tab.Pane>

                    <Tab.Pane eventKey={"second"}>
                      {
                        filteredGroups.map(group => (
                          <div
                            key={group.id}
                            className="d-flex align-items-center justify-content-between chat-tabs-content border-bottom"
                            data-target="group-chat-popup-modal"
                            onClick={() => {
                              dispatch(set_selected_group(group))
                              setwasBlocked(false)
                              setGroupTextMessage('')
                              getGroupMessages(group.id)
                              readGroupMessages(group.id, groups)
                            }}
                          >
                            <div className="d-flex align-items-center gap-3">
                              <div className="flex-shrink-0">
                                <img
                                  className="rounded-circle avatar-50"
                                  src={group.photo && group.photo !== '' ? group.photo : userGenericImage}
                                  alt="user-img"
                                  loading="lazy"
                                />
                              </div>
                              <div>
                                <h6 className="font-size-14 mb-0 fw-semibold text-nowrap overflow-hidden" style={{ maxWidth: '7rem' }}>
                                  {group.name}
                                </h6>
                                <p className="mb-0 font-size-12 fw-medium text-nowrap overflow-hidden" style={{ maxWidth: '7rem' }}>
                                  {group.latest_message ?? "Nova conversa..."}
                                </p>
                              </div>
                            </div>
                            <span className="font-size-12 fw-medium messages-counter-span">
                              {group.latest_message_time ?? ''}
                              {
                                group.unread_messages > 0 ? (
                                  <div className="counter-container bg-primary">
                                    <span className="counter-number">{group.unread_messages}</span>
                                  </div>
                                ) : ''
                              }
                            </span>
                          </div>
                        ))
                      }
                    </Tab.Pane>

                    <Tab.Pane eventKey={"third"}>
                      {
                        filteredNewFriends.map(friend => {
                          let currentUserStatus = friend.chat_status

                          return (
                            <div
                              key={friend.id}
                              className="d-flex align-items-center justify-content-between chat-tabs-content border-bottom contact"
                              data-target="chat-popup-modal"
                              onClick={() => {
                                dispatch(set_selected_friend(friend))
                                setTextMessage('')
                                getMessages(friend.id)
                                readMessages(friend.id)
                                readFriendMessages(friend.id, friends)
                              }}
                            >
                              <div className="d-flex align-items-center gap-3">
                                <div className={`iq-profile-avatar ${currentUserStatus === 'online' ? 'status-online' : currentUserStatus === 'away' ? 'status-away' : 'status-offline'}`}>
                                  <img
                                    className="rounded-circle avatar-50"
                                    src={friend.user_about.image_profile ?? userGenericImage}
                                    alt="user-img"
                                    loading="lazy"
                                  />
                                </div>
                                <div>
                                  <h6 className="font-size-14 mb-0 fw-semibold">
                                    {friend.name}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
              <div className="right-sidebar-toggle bg-primary text-white mt-3 d-flex">
                <span className="material-symbols-outlined">chat</span>
              </div>
              <div className="conversion-button">
                <Button
                  onClick={() => history('/chat/index')}
                  as="a"
                  className="btn btn-primary w-100 py-3 d-block rounded-0"
                >
                  Ver todas as conversas
                </Button>
              </div>
              <div className="right-sidebar-toggle bg-primary text-white mt-3 d-flex" onClick={minirightsidebar}>
                <span className="material-symbols-outlined">chat</span>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>

      <div className="chat-popup-modal div-chat-onmobile"
        id="chat-popup-modal"
        style={{
          height: isMobile ? (isKeyboardOpen ? '55%' : '100%') : '39rem',
        }}
      >
        <div className="bg-primary p-3 d-flex align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-3">
            <div className="image flex-shrink-0">
              {selectedFriend && selectedFriend.id == '0' ?
                <img
                  src={selectedFriend?.user_about?.image_profile ?? logoAtmoAi}
                  alt="img"
                  className="img-fluid avatar-45 rounded-circle object-cover"
                /> : (
                  <img
                    src={selectedFriend?.user_about?.image_profile ?? userGenericImage}
                    alt="img"
                    className="img-fluid avatar-45 rounded-circle object-cover"
                  />
                )}
            </div>
            <div className="content">
              <h6 className="mb-0 font-size-14 text-white text-nowrap overflow-hidden" style={{ maxWidth: '10rem' }}>{selectedFriend ? selectedFriend.name : ''}</h6>
              {selectedFriend && selectedFriend.id !== '0' &&
                <span className="d-inline-block lh-1 font-size-12 text-white">
                  <span className={`d-inline-block rounded-circle border-5 p-1 align-baseline me-1 ${selectedFriend && selectedFriend.chat_status === 'online' ? 'bg-success' : selectedFriend && selectedFriend.chat_status === 'away' ? 'bg-danger' : 'bg-gray'}`}></span>
                  {selectedFriend && selectedFriend.chat_status === 'online' ? 'Online' : selectedFriend && selectedFriend.chat_status === 'away' ? 'Ocupado' : 'Offline'}
                </span>
              }
              {selectedFriend && selectedFriend.id == '0' &&
                <span className="d-inline-block lh-1 font-size-12 text-white">
                  <span className={`d-inline-block rounded-circle border-5 p-1 align-baseline me-1 bg-success`}></span>
                  {'Online'}
                </span>
              }
            </div>
          </div>
          {selectedFriend && selectedFriend.id == '0' &&
            <div className='chat-header-icons d-inline-flex ms-auto'>
              <Dropdown
                onSelect={handleSelect}
                className='bg-primary-subtle d-flex align-items-center justify-content-center'
                as='span'
              >
                <Dropdown.Toggle as='svg' bsPrefix=' '
                  className='icon-20 nav-hide-arrow cursor-pointer pe-0'
                  id='dropdownMenuButton-09'
                  data-bs-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                  role='menu'
                  width='24'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M10 20.6788C10 21.9595 11.0378 23 12.3113 23C13.5868 23 14.6265 21.9595 14.6265 20.6788C14.6265 19.3981 13.5868 18.3576 12.3113 18.3576C11.0378 18.3576 10 19.3981 10 20.6788ZM10 12.0005C10 13.2812 11.0378 14.3217 12.3113 14.3217C13.5868 14.3217 14.6265 13.2812 14.6265 12.0005C14.6265 10.7198 13.5868 9.67929 12.3113 9.67929C11.0378 9.67929 10 10.7198 10 12.0005ZM12.3113 5.64239C11.0378 5.64239 10 4.60192 10 3.3212C10 2.04047 11.0378 1 12.3113 1C13.5868 1 14.6265 2.04047 14.6265 3.3212C14.6265 4.60192 13.5868 5.64239 12.3113 5.64239Z'
                    fill='currentColor'
                  ></path>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className='dropdown-menu-right'
                  aria-labelledby='dropdownMenuButton-09'
                >
                  <Dropdown.Item eventKey="text">Tipo de chat: Texto</Dropdown.Item>
                  <Dropdown.Item eventKey="image">Tipo de chat: Imagem</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          }

          {selectedFriend && selectedFriend.id !== '0' &&
            <div className='chat-header-icons d-inline-flex ms-auto'>
              <Dropdown
                onSelect={handleSelect}
                className='bg-primary-subtle d-flex align-items-center justify-content-center'
                as='span'
              >
                <Dropdown.Toggle as='svg' bsPrefix=' '
                  className='icon-20 nav-hide-arrow cursor-pointer pe-0'
                  id='dropdownMenuButton-09'
                  data-bs-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                  role='menu'
                  width='24'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M10 20.6788C10 21.9595 11.0378 23 12.3113 23C13.5868 23 14.6265 21.9595 14.6265 20.6788C14.6265 19.3981 13.5868 18.3576 12.3113 18.3576C11.0378 18.3576 10 19.3981 10 20.6788ZM10 12.0005C10 13.2812 11.0378 14.3217 12.3113 14.3217C13.5868 14.3217 14.6265 13.2812 14.6265 12.0005C14.6265 10.7198 13.5868 9.67929 12.3113 9.67929C11.0378 9.67929 10 10.7198 10 12.0005ZM12.3113 5.64239C11.0378 5.64239 10 4.60192 10 3.3212C10 2.04047 11.0378 1 12.3113 1C13.5868 1 14.6265 2.04047 14.6265 3.3212C14.6265 4.60192 13.5868 5.64239 12.3113 5.64239Z'
                    fill='currentColor'
                  ></path>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className='dropdown-menu-right'
                  aria-labelledby='dropdownMenuButton-09'
                >
                  <Dropdown.Item eventKey="text" onClick={() => blockContact(selectedFriend.id)}>
                    {
                      blocked ? (
                        'Desbloquear'
                      ) : (
                        'Bloquear'
                      )
                    }
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          }

          <div className="chat-popup-modal-close lh-1" type="button" onClick={() => dispatch(set_selected_friend(null))}>
            <span className="material-symbols-outlined font-size-18 text-white">
              close
            </span>
          </div>
        </div>

        <div className="chat-popup-body p-3 border-bottom div-body-chat-onmobile"
          style={{
            height: isKeyboardOpen ? '100%' : '80%', // Reduz a altura do chat se o teclado está aberto
            overflowY: 'auto',
          }}
        >
          <ul className="ul-content-onmobile list-unstyled" ref={chatBodyRef}
            style={{
              height: isMobile ? (isKeyboardOpen ? '40vh' : '100%') : '28rem',
              overflowY: isMobile ? 'auto' : 'auto',
            }}
          >
            {messages?.map((msg) => {
              if (msg.sender_id == loged_user) {
                return (
                  <li className="mt-3 message-box" key={`message_${msg.id}`} ref={(el) => (messageRefs.current[msg.id] = el)}>
                    <div className="text-end">
                      <div className="d-flex align-items-center justify-content-end gap-md-2 container_message">
                        {
                          !msg.user_removed && !deletedMessage.includes(msg.id) ? (
                            <Dropdown
                              className='dropdown cursor-pointer more options_button'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-original-title='More'
                            >
                              <Dropdown.Toggle
                                className='lh-1'
                                id='post-option'
                                data-bs-toggle='dropdown'
                                bsPrefix=' '
                                as='span'
                              >
                                <span className='material-symbols-outlined text-dark'>
                                  more_vert
                                </span>
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                className='dropdown-menu dropdown-menu-right'
                                aria-labelledby='post-option'
                              >
                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => copyMessage(editedMessages.find(message => message.id === msg.id)?.text ?? msg.message)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>content_copy</span>copiar texto
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => {
                                    setShowEdit(true)
                                    setEditedChatId(msg.id)
                                    setNewText(msg.message)
                                  }}
                                >
                                  <span
                                    className='material-symbols-outlined align-middle font-size-20 me-1'
                                  >edit</span>editar
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => deleteMessage(msg.id, false, msg.receiver_id)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>delete</span>
                                  deletar
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : ''
                        }

                        {
                          (msg.user_removed || deletedMessage.includes(msg.id)) ? (
                            <div className="d-inline-block py-2 px-3 bg-primary-subtle chat-popup-message messageAnchor message-right font-size-12 fw-medium" style={{ marginRight: '5px' }} onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                              <i className='mr-2 mb-0'>
                                Mensagem apagada
                              </i>
                            </div>
                          ) : showEdit && editedChatId === msg.id ? (
                            <div>
                              <input
                                type='text'
                                className='form-control rounded px-0 mb-3'
                                style={{ border: 'none' }}
                                value={newText}
                                onChange={(e) => setNewText(e.target.value)}
                              />

                              <button type='button' className='btn btn-primary px-4' style={{ marginRight: '5px' }} onClick={() => editMessage(msg.id, false, msg.receiver_id)}>
                                <div className='fw-semibold'>Salvar</div>
                              </button>

                              <button type='button' className='btn btn-danger px-4 ml-5' onClick={() => {
                                setShowEdit(false)
                                setNewText(msg.message)
                                setEditedChatId('')
                              }}>
                                Cancelar
                              </button>
                            </div>
                          ) : editedMessages && editedMessages.some(message => message.id === msg.id) ? (
                            <div className="d-inline-block py-2 px-3 bg-primary-subtle chat-popup-message messageAnchor message-right font-size-12 fw-medium" style={{ marginRight: '5px' }} onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                              <TextMessageComponent message={msg} friendName={selectedFriend?.name} editedText={editedMessages.find(message => message.id === msg.id).text} />
                            </div>
                          ) : ( msg.type === 'text' ? (
                            <div
                              className="d-inline-block py-2 px-3 chat-popup-message messageAnchor font-size-12 fw-medium message-right"
                              style={{ marginRight: '5px', backgroundColor: "grey", color: "white" }}
                              onClick={() => scrollToMessage(msg.reply_id ?? '')}
                            >
                              <TextMessageComponent message={msg} friendName={selectedFriend?.name} />
                            </div>
                          ) : (
                            <div className="d-inline-block py-2 px-3 bg-light chat-popup-message messageAnchor font-size-12 fw-medium message-right" style={{ marginRight: '5px' }} onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                              <ImageMessageComponent message={msg} friendName={selectedFriend?.name} />
                            </div>
                          ))
                        }
                      </div>

                      <IoCheckmarkDoneSharp style={{ color: msg.readed ? '#50B5FF' : '' }} />
                      <span className="mt-1 d-block time font-size-10 fst-italic">
                        {msg.formatted_created_at}
                      </span>
                    </div>
                  </li>
                );
              } else {
                return (
                  <li className="mt-2" key={`message_${msg.id}`} ref={(el) => (messageRefs.current[msg.id] = el)}>
                    <div className="text-start">
                      <div className='d-flex align-items-center justify-content-start gap-md-2 container_message'>
                        <div className="messageAnchor" onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                          {
                            (msg.user_removed || deletedMessage.includes(msg.id)) ? (
                              <div className="d-inline-block py-2 px-3 bg-gray-subtle chat-popup-message font-size-12 fw-medium">
                                <i className="mr-2 mb-0">Mensagem apagada</i>
                              </div>
                            ) : (editedMessages && editedMessages.some(message => message.id === msg.id)) ? (
                              <div className="d-inline-block py-2 px-3 bg-gray-subtle chat-popup-message font-size-12 fw-medium">
                                <TextMessageComponent message={msg} friendName='Você' editedText={editedMessages.find(message => message.id === msg.id).text} />
                              </div>
                            ) : (
                              msg.type === 'text' && (
                                <div
                                  className="d-inline-block py-2 px-3 chat-popup-message font-size-12 fw-medium"
                                  style={{ marginRight: '5px', backgroundColor: "grey", color: "white" }}
                                >
                                  <TextMessageComponent message={msg} friendName='Você' />
                                </div>
                              )
                            )
                          }

                          {msg.type === 'image' && (
                            <div className="d-inline-block py-2 px-3 bg-light chat-popup-message font-size-12 fw-medium" style={{ marginRight: '5px' }}>
                              <ImageMessageComponent message={msg} friendName='Você' />   
                            </div>
                          )}
                        </div>

                        {
                          !msg.user_removed && !deletedMessage.includes(msg.id) ? (
                            <Dropdown
                              className='dropdown cursor-pointer more options_button'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-original-title='More'
                            >
                              <Dropdown.Toggle
                                className='lh-1'
                                id='post-option'
                                data-bs-toggle='dropdown'
                                bsPrefix=' '
                                as='span'
                              >
                                <span className='material-symbols-outlined text-dark'>
                                  more_vert
                                </span>
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                className='dropdown-menu dropdown-menu-right'
                                aria-labelledby='post-option'
                              >
                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => copyMessage(editedMessages.find(message => message.id === msg.id)?.text ?? msg.message)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>content_copy</span>copiar texto
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => setReplyMessage(msg.message, msg.id)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>reply</span>responder
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : ''
                        }
                      </div>

                      <span className="mt-1 d-block time font-size-10 fst-italic">
                        {msg.formatted_created_at}
                      </span>
                    </div>
                  </li>
                );
              }
            })}
            {isLoading && (
              <li className="loading-message">
                <div className="text-primary" role="status">
                  <span className="sr-only">Carregando...</span>
                </div>
              </li>
            )}
          </ul>

          <button
            className={`scroll-to-bottom-btn btn btn-primary ${showScrollButton ? 'visible' : 'invisible'}`}
            onClick={scrollToBottom}
          >
            <FaArrowDown />
          </button>
        </div>

        <div className="chat-popup-footer p-3 chat-input-footer-onmobile">
          {showPicker && (
            <EmojiPicker style={{ position: 'absolute', bottom: '6rem', width: '90%', height: '400px' }} onEmojiClick={onEmojiClick} />
          )}

          {file && (
            <div className="card filePreview replyMessagePopUpPreviewPreview w-100 z-3">
              <img
                className='rounded mx-3 my-3'
                src={URL.createObjectURL(file)}
                alt="Imagem escolhida"
                style={{ maxWidth: '15%'}}
              />
              <CloseButton
                onClick={removeImage}
                style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor:'white', color: '#ff0000' }}
              />
            </div>   
          )}

          {messageToReply && (
            <div className="card replyMessagePopUpPreviewPreview w-100 z-3">
              {
                isImageLink(messageToReply) ? (
                  <div className='replyMessageContainer'><b>{selectedFriend?.name}</b>: 
                    <img
                      className='rounded mx-3 my-3'
                      src={messageToReply}
                      alt="Imagem"
                      style={{ maxWidth: '15%'}}
                    />
                  </div>
                ) : (
                  <div className='replyMessageContainer'><b>{selectedFriend?.name}</b>: {messageToReply}</div>
                )
              }

              <CloseButton
                onClick={() => {
                  setMessageToReply('')
                  setMessageToReplyAuthor('')
                  setMessageToReplyId(null) 
                }}
                style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor:'white', color: '#ff0000' }}
              />
            </div>   
          )}

          <div className="chat-popup-form">
            <form
              className="d-flex"
              onSubmit={(e) => {
                e.preventDefault();
                sendMessage(e);
              }}
            >
              <div className="chat-attachment d-flex align-items-center pe-2" style={{ position: 'relative', cursor: 'pointer' }}>
                <span className="material-symbols-outlined text-dark" style={{ fontSize: '24px' }}>
                  attach_file
                </span>

                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="opacity-0 position-absolute top-0 start-0"
                  style={{
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                    padding: '0'
                  }}
                />
              </div>

              <div className='chat-attagement d-flex'>
                <Link to='#' className='d-flex align-items-center pe-3' onClick={(e) => {
                  e.preventDefault();
                  setShowPicker((val) => !val);
                }}>
                  <svg
                    className='icon-24'
                    width='24'
                    viewBox='0 0 24 25'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clipPath='url(#clip0_156_599)'>
                      <path
                        d='M20.4853 4.01473C18.2188 1.74823 15.2053 0.5 12 0.5C8.79469 0.5 5.78119 1.74823 3.51473 4.01473C1.24819 6.28119 0 9.29469 0 12.5C0 15.7053 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2053 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29469 22.7518 6.28119 20.4853 4.01473ZM12 23.0714C6.17091 23.0714 1.42856 18.3291 1.42856 12.5C1.42856 6.67091 6.17091 1.92856 12 1.92856C17.8291 1.92856 22.5714 6.67091 22.5714 12.5C22.5714 18.3291 17.8291 23.0714 12 23.0714Z'
                        fill='currentcolor'
                      ></path>
                      <path
                        d='M9.40398 9.3309C8.23431 8.16114 6.33104 8.16123 5.16136 9.3309C4.88241 9.60981 4.88241 10.0621 5.16136 10.3411C5.44036 10.62 5.89266 10.62 6.17157 10.3411C6.78432 9.72836 7.78126 9.7284 8.39392 10.3411C8.53342 10.4806 8.71618 10.5503 8.89895 10.5503C9.08171 10.5503 9.26457 10.4806 9.40398 10.3411C9.68293 10.0621 9.68293 9.60986 9.40398 9.3309Z'
                        fill='currentcolor'
                      ></path>
                      <path
                        d='M18.8384 9.3309C17.6688 8.16123 15.7655 8.16114 14.5958 9.3309C14.3169 9.60981 14.3169 10.0621 14.5958 10.3411C14.8748 10.62 15.3271 10.62 15.606 10.3411C16.2187 9.72836 17.2156 9.72831 17.8284 10.3411C17.9679 10.4806 18.1506 10.5503 18.3334 10.5503C18.5162 10.5503 18.699 10.4806 18.8384 10.3411C19.1174 10.0621 19.1174 9.60986 18.8384 9.3309Z'
                        fill='currentcolor'
                      ></path>
                      <path
                        d='M18.3335 13.024H5.6668C5.2723 13.024 4.95251 13.3438 4.95251 13.7383C4.95251 17.6243 8.11409 20.7859 12.0001 20.7859C15.8862 20.7859 19.0477 17.6243 19.0477 13.7383C19.0477 13.3438 18.728 13.024 18.3335 13.024ZM12.0001 19.3573C9.14366 19.3573 6.77816 17.215 6.42626 14.4525H17.574C17.2221 17.215 14.8566 19.3573 12.0001 19.3573Z'
                        fill='currentcolor'
                      ></path>
                    </g>
                    <defs>
                      <clipPath>
                        <rect
                          width='24'
                          height='24'
                          fill='white'
                          transform='translate(0 0.5)'
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </Link>
              </div>

              <input
                type="text"
                className="form-control"
                disabled={wasBlocked}
                placeholder={
                  selectedFriend?.id === '0'
                    ? (selectedMode === "text"
                      ? "Mensagem Atmo Ai.."
                      : selectedMode === "image"
                        ? "Crie uma imagem.."
                        : "Digite aqui...")
                    : "Digite aqui..."
                }
                onChange={(e) => setTextMessage(e.target.value)}
                value={textMessage}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    sendMessage(e);
                  }
                }}
                onFocus={handleFocus} // Define foco para detectar teclado aberto
                onBlur={handleBlur}   // Define blur para detectar teclado fechado
              />

              {
                isSendingMessage ? (
                  <button
                    disabled={true}
                    className="chat-popup-form-button btn btn-primary"
                  >
                    <div className="spinner-border spinner-border-sm" role="status"></div>
                  </button>
                ) : (
                  <button
                    type="submit"
                    disabled={wasBlocked}
                    className="chat-popup-form-button btn btn-primary"
                  >
                    <span className="material-symbols-outlined font-size-18 icon-rtl">
                      send
                    </span>
                  </button>
                )
              }
            </form>
          </div>
        </div>
      </div>

      <div className="group-chat-popup-modal div-chat-onmobile"
        id="group-chat-popup-modal"
        style={{
          height: isMobile ? (isKeyboardOpen ? '55%' : '100%') : '39rem',
        }}
      >
        <div className="bg-primary p-3 d-flex align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-3">
            <div className="image flex-shrink-0">
              <img
                src={selectedGroup?.photo ?? userGenericImage}
                alt="img"
                className="img-fluid avatar-45 rounded-circle object-cover"
              />
            </div>
            <div className="content">
              <h6 className="mb-0 font-size-14 text-white">{selectedGroup ? selectedGroup.name : ''}</h6>
            </div>
          </div>
          <div className="group-chat-popup-modal-close lh-1" type="button" onClick={() => dispatch(set_selected_group(null))}>
            <span className="material-symbols-outlined font-size-18 text-white">
              close
            </span>
          </div>
        </div>

        <div className="chat-popup-body p-2 border-bottom div-body-chat-onmobile"
          style={{
            height: isKeyboardOpen ? '100%' : '80%', // Reduz a altura do chat se o teclado está aberto
            overflowY: 'auto',
          }}>
          <ul className="ul-content-onmobile list-unstyled" ref={groupChatBodyRef}
            style={{
              height: isMobile ? (isKeyboardOpen ? '40vh' : '100%') : '28rem',
              overflowY: isMobile ? 'auto' : 'auto',
            }}
          >
            {groupMessages?.map((msg) => {
              if (msg.sender_id == loged_user) {
                return (
                  <li className="mt-3 message-box" key={`message_${msg.id}`} ref={(el) => (messageRefs.current[msg.id] = el)}>
                    <div className="text-end ">
                      <div className="d-flex align-items-center justify-content-end gap-md-2 container_message">
                        {
                          !msg.user_removed && !deletedMessage.includes(msg.id) ? (
                            <Dropdown
                              className='dropdown cursor-pointer more options_button'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-original-title='More'
                            >
                              <Dropdown.Toggle
                                className='lh-1'
                                id='post-option'
                                data-bs-toggle='dropdown'
                                bsPrefix=' '
                                as='span'
                              >
                                <span className='material-symbols-outlined text-dark'>
                                  more_vert
                                </span>
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                className='dropdown-menu dropdown-menu-right'
                                aria-labelledby='post-option'
                              >
                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => copyMessage(editedMessages.find(message => message.id === msg.id)?.text ?? msg.message)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>content_copy</span>copiar texto
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => {
                                    setShowEdit(true)
                                    setEditedChatId(msg.id)
                                    setNewText(msg.message)
                                  }}
                                >
                                  <span
                                    className='material-symbols-outlined align-middle font-size-20 me-1'
                                  >edit</span>editar
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => deleteMessage(msg.id, false, msg.receiver_id)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>delete</span>
                                  deletar
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : ''
                        }

                        {
                          (msg.user_removed || deletedMessage.includes(msg.id)) ? (
                            <div className="d-inline-block py-2 px-3 bg-primary-subtle chat-popup-message messageAnchor message-right font-size-12 fw-medium" style={{ marginRight: '5px' }} onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                              <i className='mr-2 mb-0'>
                                Mensagem apagada
                              </i>
                            </div>
                          ) : showEdit && editedChatId === msg.id ? (
                            <div>
                              <input
                                type='text'
                                className='form-control rounded px-0 mb-3'
                                style={{ border: 'none' }}
                                value={newText}
                                onChange={(e) => setNewText(e.target.value)}
                              />

                              <button type='button' className='btn btn-primary px-4' style={{ marginRight: '5px' }} onClick={() => editMessage(msg.id, false, msg.receiver_id)}>
                                <div className='fw-semibold'>Salvar</div>
                              </button>

                              <button type='button' className='btn btn-danger px-4 ml-5' onClick={() => {
                                setShowEdit(false)
                                setNewText(msg.message)
                                setEditedChatId('')
                              }}>
                                Cancelar
                              </button>
                            </div>
                          ) : editedMessages && editedMessages.some(message => message.id === msg.id) ? (
                            <div className="d-inline-block py-2 px-3 bg-primary-subtle chat-popup-message messageAnchor message-right font-size-12 fw-medium" style={{ marginRight: '5px' }} onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                              <TextMessageComponent message={msg} friendName={msg?.reply?.sender_name} editedText={editedMessages.find(message => message.id === msg.id).text} />
                            </div>
                          ) : (
                            <div className="d-inline-block py-2 px-3 bg-primary-subtle chat-popup-message messageAnchor message-right font-size-12 fw-medium" style={{ marginRight: '5px' }} onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                              <TextMessageComponent message={msg} friendName={msg?.reply?.sender_name} />
                            </div>
                          )
                        }
                      </div>

                      <span className="mt-1 d-block time font-size-10 fst-italic">
                        {msg.formatted_created_at}
                      </span>
                    </div>
                  </li>
                );
              } else {
                return (
                  <li className="mt-2" key={`message_${msg.id}`} ref={(el) => (messageRefs.current[msg.id] = el)}>
                    <div className="text-start">
                      <div className="d-flex align-items-center justify-content-start gap-md-2 container_message">
                        <div className="messageAnchor" onClick={() => scrollToMessage(msg.reply_id ?? '')}>
                          {
                            (msg.user_removed || deletedMessage.includes(msg.id)) ? (
                              <div className="d-inline-block py-2 px-3 bg-gray-subtle chat-popup-message font-size-12 fw-medium">
                                <i className='mr-2 mb-0'>
                                  Mensagem apagada
                                </i>
                              </div>
                            ) : editedMessages && editedMessages.some(message => message.id === msg.id) ? (
                              <div className="d-inline-block py-2 px-3 bg-gray-subtle chat-popup-message font-size-12 fw-medium">
                                <TextMessageComponent message={msg} friendName={msg?.reply?.sender_name} editedText={editedMessages.find(message => message.id === msg.id).text} />
                              </div>
                            ) : (
                              <div className="d-inline-block py-2 px-3 bg-gray-subtle chat-popup-message font-size-12 fw-medium">
                                <TextMessageComponent message={msg} friendName={msg?.reply?.sender_name} />
                              </div>
                            )
                          }
                        </div>

                        {
                          !msg.user_removed && !deletedMessage.includes(msg.id) ? (
                            <Dropdown
                              className='dropdown cursor-pointer more options_button'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-original-title='More'
                            >
                              <Dropdown.Toggle
                                className='lh-1'
                                id='post-option'
                                data-bs-toggle='dropdown'
                                bsPrefix=' '
                                as='span'
                              >
                                <span className='material-symbols-outlined text-dark'>
                                  more_vert
                                </span>
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                className='dropdown-menu dropdown-menu-right'
                                aria-labelledby='post-option'
                              >
                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => copyMessage(editedMessages.find(message => message.id === msg.id)?.text ?? msg.message)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>content_copy</span>copiar texto
                                </Dropdown.Item>

                                <Dropdown.Item
                                  className=''
                                  href='#'
                                  data-bs-toggle='modal'
                                  data-bs-target='#post-modal'
                                  onClick={() => setReplyMessage(msg.message, msg.id, msg.name)}
                                >
                                  <span className='material-symbols-outlined align-middle font-size-20 me-1'>reply</span>responder
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : ''
                        }

                      </div>

                      <span className="mt-1 d-block time font-size-10 fst-italic">
                        {msg.name} - {msg.formatted_created_at}
                      </span>
                    </div>
                  </li>
                );
              }
            })}
          </ul>

          <button
            className={`scroll-to-bottom-btn btn btn-primary ${showGroupScrollButton ? 'visible' : 'invisible'}`}
            onClick={scrollToBottomGroup}
          >
            <FaArrowDown />
          </button>
        </div>

        <div className="chat-popup-footer p-3 chat-input-footer-onmobile">
          {showGroupPicker && (
            <EmojiPicker style={{ position: 'absolute', bottom: '6rem', width: '90%', height: '400px' }} onEmojiClick={onGroupEmojiClick} />
          )}

          {messageToReply && (
            <div className="card replyMessagePopUpPreviewPreview w-100 z-3">
              {
                isImageLink(messageToReply) ? (
                  <div className='replyMessageContainer'><b>{messageAuthor}</b>: 
                    <img
                      className='rounded mx-3 my-3'
                      src={messageToReply}
                      alt="Imagem"
                      style={{ maxWidth: '15%'}}
                    />
                  </div>
                ) : (
                  <div className='replyMessageContainer'><b>{messageAuthor}</b>: {messageToReply}</div>
                )
              }

              <CloseButton
                onClick={() => {
                  setMessageToReply('')
                  setMessageToReplyAuthor('')
                  setMessageToReplyId(null) 
                }}
                style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor:'white', color: '#ff0000' }}
              />
            </div>   
          )}

          <div className="chat-popup-form">
            <form
              className="d-flex"
              onSubmit={(e) => {
                e.preventDefault();
                sendMessage(e, selectedGroup?.id);
              }}
            >
              <div className='chat-attagement d-flex'>
                <Link to='#' className='d-flex align-items-center pe-3' onClick={(e) => {
                  e.preventDefault();
                  setShowGroupPicker((val) => !val);
                }}>
                  <svg
                    className='icon-24'
                    width='24'
                    viewBox='0 0 24 25'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clipPath='url(#clip0_156_599)'>
                      <path
                        d='M20.4853 4.01473C18.2188 1.74823 15.2053 0.5 12 0.5C8.79469 0.5 5.78119 1.74823 3.51473 4.01473C1.24819 6.28119 0 9.29469 0 12.5C0 15.7053 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2053 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29469 22.7518 6.28119 20.4853 4.01473ZM12 23.0714C6.17091 23.0714 1.42856 18.3291 1.42856 12.5C1.42856 6.67091 6.17091 1.92856 12 1.92856C17.8291 1.92856 22.5714 6.67091 22.5714 12.5C22.5714 18.3291 17.8291 23.0714 12 23.0714Z'
                        fill='currentcolor'
                      ></path>
                      <path
                        d='M9.40398 9.3309C8.23431 8.16114 6.33104 8.16123 5.16136 9.3309C4.88241 9.60981 4.88241 10.0621 5.16136 10.3411C5.44036 10.62 5.89266 10.62 6.17157 10.3411C6.78432 9.72836 7.78126 9.7284 8.39392 10.3411C8.53342 10.4806 8.71618 10.5503 8.89895 10.5503C9.08171 10.5503 9.26457 10.4806 9.40398 10.3411C9.68293 10.0621 9.68293 9.60986 9.40398 9.3309Z'
                        fill='currentcolor'
                      ></path>
                      <path
                        d='M18.8384 9.3309C17.6688 8.16123 15.7655 8.16114 14.5958 9.3309C14.3169 9.60981 14.3169 10.0621 14.5958 10.3411C14.8748 10.62 15.3271 10.62 15.606 10.3411C16.2187 9.72836 17.2156 9.72831 17.8284 10.3411C17.9679 10.4806 18.1506 10.5503 18.3334 10.5503C18.5162 10.5503 18.699 10.4806 18.8384 10.3411C19.1174 10.0621 19.1174 9.60986 18.8384 9.3309Z'
                        fill='currentcolor'
                      ></path>
                      <path
                        d='M18.3335 13.024H5.6668C5.2723 13.024 4.95251 13.3438 4.95251 13.7383C4.95251 17.6243 8.11409 20.7859 12.0001 20.7859C15.8862 20.7859 19.0477 17.6243 19.0477 13.7383C19.0477 13.3438 18.728 13.024 18.3335 13.024ZM12.0001 19.3573C9.14366 19.3573 6.77816 17.215 6.42626 14.4525H17.574C17.2221 17.215 14.8566 19.3573 12.0001 19.3573Z'
                        fill='currentcolor'
                      ></path>
                    </g>
                    <defs>
                      <clipPath>
                        <rect
                          width='24'
                          height='24'
                          fill='white'
                          transform='translate(0 0.5)'
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </Link>
              </div>

              <input
                type="text"
                className="form-control"
                placeholder="Digite aqui..."
                onChange={(e) => setGroupTextMessage(e.target.value)}
                value={groupTextMessage}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    sendMessage(e, selectedGroup?.id);
                  }
                }}
                onFocus={handleFocus} // Define foco para detectar teclado aberto
                onBlur={handleBlur}   // Define blur para detectar teclado fechado
              />

              {
                isSendingMessage ? (
                  <div className="text-primary" role="status">
                    <button
                      disabled={true}
                      className="chat-popup-form-button btn btn-primary"
                    >
                      <div className="spinner-border spinner-border-sm" role="status"></div>
                    </button>
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="chat-popup-form-button btn btn-primary"
                  >
                    <span className="material-symbols-outlined font-size-18 icon-rtl">
                      send
                    </span>
                  </button>
                )
              }
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default RightSidebar
